import React, { useState } from "react";
import api from "../../../Axios/api";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { LockOutlined } from "@material-ui/icons/";
import {
  Avatar,
  Button,
  TextField,
  Link,
  Paper,
  Grid,
  Typography,
} from "@material-ui/core";
import { withRouter, Redirect } from "react-router-dom";
import { useUserContext, loginUser } from "../../../context/UserContext";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import useStyles from "./styles";

const Login = () => {
  const classes = useStyles();
  // context
  const { dispatch } = useUserContext();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  // const [disabled, setDisable] = useState(true);

  // Snackbar
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  const initialValues = {
    email: "",
    password: "",
    remember: false,
  };
  const validationSchema = Yup.object().shape({
    email: Yup.string().email("please enter valid email").required("Required*"),
    password: Yup.string().min(7).required("Required*"),
  });
  const onSubmit = (values, props) => {
    console.log(values);
    api
      .post("/superAdmin/login", {
        ...values,
      })
      .then(function (res) {
        console.log(res);
        setTimeout(() => setIsLoggedIn(true), [10]);
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: You Have Logged In Sucessfully!",
          open: true,
        });
        return loginUser(
          dispatch,
          res.data.data.superAdmin,
          res.data.data.token
        );
      })
      .catch((error) => {
        setSnackBar({
          ...snackBarstate,
          message:
            "ERROR: " + JSON.stringify(error.response.data.error.message),
          type: "error",
          open: true,
        });
      });
  };
  return (
    <Grid container className={classes.root}>
      {isLoggedIn ? <Redirect to="/admin/dashboard" /> : ""}
      <Grid item xs={false} sm={4} md={7} className={classes.image}></Grid>
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlined />
          </Avatar>
          <Typography variant="h3">Sign-In Admin</Typography>
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
          >
            {(props) => (
              <Form className={classes.form}>
                <Field
                  as={TextField}
                  name="email"
                  margin="normal"
                  label="Email Address"
                  name="email"
                  autoFocus
                  placeholder="Enter email"
                  fullWidth
                  required
                  helperText={<ErrorMessage name="email" />}
                />
                <Field
                  as={TextField}
                  label="Password"
                  name="password"
                  placeholder="Enter password"
                  type="password"
                  fullWidth
                  required
                  helperText={<ErrorMessage name="password" />}
                />
                {/* <Field
                  as={FormControlLabel}
                  name="remember"
                  control={<Checkbox color="primary" />}
                  label="Remember me"
                /> */}
                <Button
                  // onClick={() => {
                  //   console.log(props.errors.email.length);
                  // }}
                  // disabled={disabled}
                  type="submit"
                  color="primary"
                  variant="contained"
                  className={classes.submit}
                  fullWidth
                >
                  Sign In
                </Button>
                <Grid container justify="space-between">
                  <Grid item>
                    <Link href="/admin/forget-password" variant="body2">
                      Forgot password?
                    </Link>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </div>
      </Grid>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={3000}
        onClose={handleCloseSnackBar}
        key={vertical + horizontal}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackBar}
          severity={snackBarstate.type}
        >
          {snackBarstate.message}
        </MuiAlert>
      </Snackbar>
    </Grid>
  );
};

export default withRouter(Login);
